// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/* 来电弹窗样式覆盖（如其他地方用到 Notification 可保留） */\n.video-call-notify {\n  width: 340px !important;\n}\n.video-call-notify .el-notification__content {\n  padding: 4px 0 0 0;\n}\n", ""]);
// Exports
module.exports = exports;
